import { ChangeDetectionStrategy, Component, inject, input } from '@angular/core';
import { Router } from '@angular/router';
import { PdfService } from '../service';

@Component({
  selector: 'cfp-print-button',
  templateUrl: './print-button.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PrintButtonComponent {
  public readonly btnClass = input<string>('btn btn-primary');
  public readonly routerUrl = input<string>();
  public readonly fileName = input.required<string>();

  public get loading() {
    return this.pdfService.isLoading();
  }

  private readonly router = inject(Router);
  private readonly pdfService = inject(PdfService);

  protected print(): void {
    this.pdfService.download(this.routerUrl() || this.router.url, this.fileName());
  }
}
